module.exports = __webpack_public_path__ + "img/40_79.04be430f.png";